// SMS follow-up automation API.
// Backend wires the routes under `/api/sms-followups` and the per-dealer
// settings PATCH on `/api/dealers/{id}/sms-automation`.
import { apiFetch } from './client';

export const smsFollowupsApi = {
  list: (params) => apiFetch('/api/sms-followups', { params }),
  runDue: (params) =>
    apiFetch('/api/sms-followups/run-due', {
      method: 'POST',
      params,
      body: {},
    }),
  updateAutomation: (dealerId, body) =>
    apiFetch(`/api/dealers/${dealerId}/sms-automation`, {
      method: 'PATCH',
      body,
    }),
};
